import { RumInitConfiguration } from "@datadog/browser-rum";
import { getAPIOrigin, getVar } from "config";
import { getEnvironment } from "helpers/getEnvironment";

export const config: RumInitConfiguration = {
  applicationId: "bbce78d6-4bf2-4677-9122-ac1742c843a3",
  clientToken: "pub702c4d6867d68f0e52e6b57923a1b292",
  site: "datadoghq.com",
  service: "remo",
  version: getVar("REACT_APP_VERSION"),
  sampleRate: 100,
  replaySampleRate: 100,
  trackInteractions: true,
  useCrossSiteSessionCookie: true,
  trackSessionAcrossSubdomains: true,
  allowedTracingOrigins: [getAPIOrigin()],
  silentMultipleInit: false,
  env: getEnvironment(),
};
